export default __webpack_public_path__ + "static/media/myMetlife-logo.f7e11118.png";